import { render, staticRenderFns } from "./CcTags.ts.vue?vue&type=template&id=2675ef40"
import script from "./CcTags.ts.vue?vue&type=script&lang=ts"
export * from "./CcTags.ts.vue?vue&type=script&lang=ts"
import style0 from "./CcTags.ts.vue?vue&type=style&index=0&id=2675ef40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports